import React from "react";
import { browserHistory } from "react-router";
import { Button } from "../spocketUI";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Actions
import { showModal } from "../../actions/ui";
import { createCustomBuildStore } from "../module/store/customBuild";

import {
  PageContainer,
  Content,
  Footer,
  Title,
  List,
  Logo,
} from "./StoreBuilderStyle";

// Images
import logo from "../images/spocket-logo.svg";
import checkIcon from "../images/icon-checkmark.svg";
import storeImage from "../images/store-image.jpg";

const features = [
  "customized for you",
  "in 48 hours",
  "10 exclusive products included",
  "for only $19",
];

const StoreBuilder = ({ showModal, createCustomBuildStore }) => {
  return (
    <PageContainer>
      <Content>
        <Logo>
          <img src={logo} alt="Spocket" />
        </Logo>
        <Title>
          We will <span>design</span> and <span>build</span> your store
        </Title>

        {features.map((feature, index) => {
          return (
            <List key={index}>
              <img src={checkIcon} alt="Check" /> {feature}
            </List>
          );
        })}

        <Button
          className="StoreBuilder__button-primary"
          variant="primaryBig"
          onClick={() => {
            createCustomBuildStore();
            showModal("STORE_DETAILS_MODAL");
          }}
        >
          Get my customized store NOW
        </Button>
        <Button
          className="StoreBuilder__button-text"
          variant="text"
          onClick={() => browserHistory.push("/search")}
        >
          No thanks, skip this for now
        </Button>
      </Content>

      <Footer>
        <img src={storeImage} alt="Store" />
      </Footer>
    </PageContainer>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showModal, createCustomBuildStore }, dispatch);
}
export default connect(
  null,
  mapDispatchToProps
)(StoreBuilder);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/StoreBuilder.js